import {
  fetchPredictions as fetchAllPredictions,
  PLACES_TYPES,
} from '@sg/garnish';

import { getEnvVars } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

export async function fetchPredictions(searchString: string) {
  const { GOOGLE_API_KEY } = getEnvVars();

  const data = await fetchAllPredictions({
    input: searchString,
    apiKey: GOOGLE_API_KEY,
    placesTypes: [PLACES_TYPES.GEOCODE],
  });

  return data.predictions;
}
